import React, { Component } from 'react';
import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.module.css';
import SvgCalendar from '../../../../others/svg_dist/Calendar';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Polish from 'date-fns/locale/pl';
import 'moment/locale/pl';

const Wrapper = styled.div<{ disabled?: boolean }>`
	border: 2px solid #04a4ec;
	display: flex;
	position: relative;
	height: 50px;
	border-radius: 5px;
	width: 150px;
	font-size: 16px;
	.react-datepicker-wrapper {
		height: 100%;
		width: ${({ disabled }) => (disabled ? '100%' : 'calc(100% - 40px)')};
		overflow: hidden;
		border-radius: 5px;
	}
	.react-datepicker__input-container {
		height: 100%;
	}
	input {
		all: unset;
		width: 100%;
		height: 100%;
		text-align: center;
		color: #fff;
		font-weight: 600;
	}
	input::placeholder {
		color: #d7d7d7;
	}
	${({ disabled }) =>
		disabled &&
		`
		pointer-events: none;
		user-select: none;
	`}
`;

const IconContainer = styled.div`
	position: absolute;
	right: 0;
	top: 0;
	width: 20px;
	background: #04a4ec;
	height: 100%;
	width: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		fill: #fff;
		width: 25px;
		height: 25px;
	}
`;

const NoValueFont = styled.p`
	position: absolute;
	top: 0;
	left: 0;
	width: calc(100% - 40px);
	height: 100%;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	pointer-events: none;
	margin: 0;
	font-weight: 600;
	cursor: pointer;
	user-select: none;
`;

type Props = {
	value: string | null;
	setValue: (date: string) => void;
	disabled?: boolean;
};

type State = {};

class DateSelect extends Component<Props, State> {
	state: State = {};

	onChange = (date: Date | null) => {
		if (!date) {
			this.props.setValue('');
			return;
		}
		if (moment(date).isBefore(Date.now())) {
			this.props.setValue('');
			return;
		}
		if (moment(date).isAfter(moment(Date.now()).add(3, 'months'))) {
			this.props.setValue('');
			return;
		}
		const d = moment(date).format('YYYY-MM-DD');
		this.props.setValue(d);
	};

	datePickerRef = React.createRef<DatePicker>();

	render() {
		return (
			<Wrapper disabled={this.props.disabled}>
				<DatePicker
					onChange={this.onChange}
					value={this.props.value || ''}
					ref={this.datePickerRef}
					// @ts-ignore
					locale={Polish}
				/>
				{!this.props.value && !this.props.disabled && (
					<NoValueFont>wybierz</NoValueFont>
				)}
				{!this.props.disabled && (
					<IconContainer
						onClick={() =>
							this.datePickerRef.current?.setOpen(true)
						}
					>
						<SvgCalendar />
					</IconContainer>
				)}
			</Wrapper>
		);
	}
}

export default DateSelect;
